import VariablesMed from "./VariablesMed";

export default VariablesMed;
